export const templatesList = [
  "azurill",
  "bronzor",
  "chikorita",
  "ditto",
  "gengar",
  "glalie",
  "kakuna",
  "leafish",
  "nosepass",
  "onyx",
  "pikachu",
  "rhyhorn",
] as const;

export const premiumTemplates: (typeof templatesList)[number][] = [
  "glalie",
  "kakuna",
  "leafish",
  "nosepass",
  "pikachu",
];

export type Template = (typeof templatesList)[number];
